import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AppErrorBoundary from "./components/AppErrorBoundary";
import "./i18n/config";
import "./styles/globals.css";
import { diagnostics } from "./lib/diagnostics";

diagnostics.initialize();

// キオスク実機のみ: 長押し (右クリック相当) のコンテキストメニューを抑止する。
// 「名前を付けて画像を保存」等からファイルダイアログ = シェル面へ到達する脱出経路になるため。
if (import.meta.env.VITE_KIOSK_MODE === "true") {
  window.addEventListener("contextmenu", (e) => e.preventDefault());
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

createRoot(container).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
